export const ADD_CATEGORIES = 'ADD_CATEGORIES'
